<script setup lang="ts">
import { Footprints } from 'lucide-vue-next';
import {useRouter} from "vue-router";

defineProps<{
  iconOnly?: boolean;
}>();

const router = useRouter()

function openApp() {
  router.push('/features')
}
</script>

<template>
  <button class="btn-primary start-btn" :class="{ 'icon-only': iconOnly }" @click="openApp">
    <Footprints :size="iconOnly ? 18 : 20" fill="currentColor" />
    <span v-if="!iconOnly">Step By Step</span>
  </button>
</template>

<style scoped>
.start-btn {
  padding: 16px 40px;
  font-size: 1.25rem;
  border-radius: 30px;
}

@media (max-width: 768px) {
  .start-btn {
    padding: 12px 32px;
    font-size: 1.1rem;
  }
}

.start-btn.icon-only {
  padding: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>
